import { application } from "web-ui/controllers/application"
import DynamicForm from "web-ui/controllers/dynamic-form"
import DynamicFormDiscardChangesConfirmation from "web-ui/controllers/dynamic-form/discard-changes-confirmation"
import DynamicFormRefresh from "web-ui/controllers/dynamic-form/refresh"
import Textarea from "web-ui/controllers/textarea"
import TurboStreamButton from "web-ui/controllers/turbo-stream-button"
import DropdownMenu from "web-ui/controllers/dropdown-menu"
import Refresh from "web-ui/controllers/refresh"
import Popover from "web-ui/controllers/popover"
import SynchronizedForm from "web-ui/controllers/synchronized-form"
import UserTools from "web-ui/controllers/user-tools"
import ViewFormError from "web-ui/controllers/view-form-error"
import ModalDialog from "web-ui/controllers/modal-dialog"
import ComboBox from "web-ui/controllers/combo-box"
import AsyncComboBox from "web-ui/controllers/async-combo-box"
import ConfirmationField from "web-ui/controllers/confirmation-field"
import Switch from "web-ui/controllers/switch"
import OptionGroup from "web-ui/controllers/option-group"
import FieldPreview from "web-ui/controllers/field-preview"
import PassiveSubmissionForm from "web-ui/controllers/passive-submission-form"
import OptionPickerForm from "web-ui/controllers/option-picker-form"

application.register("dynamic-form", DynamicForm)
application.register("dynamic-form-discard-changes-confirmation", DynamicFormDiscardChangesConfirmation)
application.register("dynamic-form-refresh", DynamicFormRefresh)
application.register("textarea", Textarea)
application.register("turbo-stream-button", TurboStreamButton)
application.register("dropdown-menu", DropdownMenu)
application.register("refresh", Refresh)
application.register("popover", Popover)
application.register("synchronized-form", SynchronizedForm)
application.register("user-tools", UserTools)
application.register("view-form-error", ViewFormError)
application.register("modal-dialog", ModalDialog)
application.register("combo-box", ComboBox)
application.register("async-combo-box", AsyncComboBox)
application.register("confirmation-field", ConfirmationField)
application.register("switch", Switch)
application.register("option-group", OptionGroup)
application.register("field-preview", FieldPreview)
application.register("passive-submission-form", PassiveSubmissionForm)
application.register("option-picker-form", OptionPickerForm)

export { application as stimulusApplication }
